import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import './Login.css';

const OperatorSelect = () => {
  const { operators, activeOperator, setActiveOperator, loadOperators, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadOperators();
  }, [loadOperators]);

  useEffect(() => {
    if (activeOperator || operators.length <= 1) {
      navigate('/dashboard', { replace: true });
    }
  }, [activeOperator, operators.length, navigate]);

  const handleSelect = (operator) => {
    setActiveOperator(operator);
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="login-container">
      <div className="login-background"></div>
      <div className="login-overlay"></div>

      <div className="login-card">
        <div className="login-header">
          <h1>Seleccionar operador</h1>
          <p>Elegi quien va a operar esta sesion</p>
        </div>

        <div className="operator-select-list">
          {operators.map(operator => (
            <button
              key={operator.id}
              className="btn-primary"
              onClick={() => handleSelect(operator)}
              data-testid={`select-operator-${operator.id}`}
            >
              {operator.name}
            </button>
          ))}
        </div>

        <button className="btn-secondary operator-logout" onClick={logout}>
          Cerrar sesion
        </button>
      </div>
    </div>
  );
};

export default OperatorSelect;
